var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center",class:!!_vm.left || 'justify-center'},[_c('p',{staticClass:" font-bold text-blue-600"},[_c('b',[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }